import { IAdHocProject, IHatchetAiCompanyProjectOcr, IProject } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";
import { ActionTypes } from "../actions/actionTypes";

export const reducer = (state: IAdHocProject = null, action: AnyAction): IAdHocProject => {
    switch(action.type) {
        case ActionTypes.AD_HOC_OCR_V3_LOAD_PROJECT: {
            let project: IProject = null;
            if (typeof action.payload.project === 'string') {
                project = JSON.parse(action.payload.project);
            }          
            else {
                project = action.payload.project;
            }    
            let ocrs = [...action.payload.ocrs];            
            let labels = [...action.payload.labels]
            let assetUrls: string[] = action.payload.assetUrls;
            return { 
                ...state,
                project: project,
                ocrs: ocrs, 
                assetUrls: assetUrls,
                source: action.payload.source, 
                labels: labels,
                isV2: true,
                hasModel: action.payload.hasModel,
                hasRunningRequest: action.payload.hasRunningRequest,
                status: action.payload.status,
                hideGenerateModel: action.payload.hideGenerateModel
            };
            break;
        }
        case ActionTypes.AD_HOC_OCR_V3_SET_PROJECT_POSTED_STATUS: {
            let project = JSON.parse(JSON.stringify(state.project));
            if (action.payload.exportDocuments.some(r => r.requestId === project.id)) {
                return {
                    ...state,
                    status: 'Posted'
                }
            }
            else {
                return {
                    ...state
                }
            }            
            break;
        }
        default: {
            return state;
        }
    }
}